// extracted by mini-css-extract-plugin
export default {"local":"Local_local__sEHA3","infoWrapper":"Local_infoWrapper__ZeZ3E"};